import { SavedViewTabs as SharedSavedViewTabs } from '@/components/data-table'
import { SAVED_VIEW_CONFIGS, type SavedViewId } from '@/types/aircrafts'

interface SavedViewTabsProps {
  activeView: SavedViewId
  onViewChange: (viewId: SavedViewId) => void
  counts: Record<SavedViewId, number>
  isModified: boolean
  /** Views that should be disabled (e.g. location-required views when no location) */
  disabledViews?: SavedViewId[]
}

export function SavedViewTabs({
  activeView,
  onViewChange,
  counts,
  isModified,
  disabledViews = [],
}: SavedViewTabsProps) {
  return (
    <SharedSavedViewTabs
      views={SAVED_VIEW_CONFIGS}
      activeView={activeView}
      onViewChange={onViewChange}
      counts={counts}
      isModified={isModified}
      disabledViews={disabledViews}
    />
  )
}
